import React, { useState } from 'react'
import "./About.css";
import yemi from '../yemi.jpg';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faInstagram, faTwitter, faTelegram, faYoutube, faLinkedin, faTiktok } from "@fortawesome/free-brands-svg-icons"
import { Progress } from 'react-sweet-progress';
import "react-sweet-progress/lib/style.css";
import Certificates from './Certificates.js';
import ytchannel from '../ytchannel.PNG';
import resume from '../Yemane_Birhane_CV.pdf';
import yemy from '../yemy.jpg';
import addischat from './images/addis.PNG'
import addistweet from './images/addistweet.PNG'
import wetok from './images/wetok.PNG'
import mirchaye from './images/mirchaye.png'
import dec from './images/elearn.PNG'
import hms from './images/hms.PNG'
import ecom from './images/ecom.PNG'
import car from './images/car.PNG'
import dama from './images/dama.PNG'
import calc from './images/calc.PNG'
import car1 from './images/car1.PNG'
import db from "../firebase";
import Services from './Services';
import y from "./images/yy.PNG";
import ReactTypingEffect from 'react-typing-effect';
import pro from './images/pro.png';
import abt from './images/about.png';
import exp from './images/skills1.png';
import service from './images/service.jpg';
import beteseb from './images/beteseb.PNG';
import contact from './images/contactme.png';
import { faArrowAltCircleUp } from '@fortawesome/free-solid-svg-icons';

const initialValues = {
    name: "",
    subject: "",
    email: "",
    message: "",
  };

function About() {

    const [values, setValues] = useState(initialValues);
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setValues({
          ...values,
          [name]: value,
        });
      };

    const handleSubmit = (e) =>{
        alert('Your Message was Submitted. we will get Back to you Soon!');
        e.preventDefault();
        // db stuff
        db.collection("contacts").add({
            message: values.message,
            name: values.name,
            subject: values.subject,
            email: values.email,
        });
        setValues(initialValues);
        // e.target.reset();
        
    };    
    return (
        <div className="about">
            <a name="top"></a>
            <section className="s1">
                <div className="main-container">
                    <div className="greeting-wrapper" style={{backgroundColor: "black"}}>
                    <small style={{color: "green"}}>&lt;h2&gt;</small>   <h2>
                        
                    <ReactTypingEffect
                        className="hello"
                        text={["Hello I'm,"]}
                        eraseDelay="500"
                        typingDelay="1000"
                        cursorRenderer={cursor => <h4>{cursor}</h4>}
                        displayTextRenderer={(text, i) => {
                        return (
                            <h3>
                            {text.split('').map((char, i) => {
                                const key = `${i}`;
                                return (
                                <span
                                    key={key}
                                    style={i%2 === 0 ? { color: 'green'} : {color: 'green'}}
                                >{char}</span>
                                );
                            })}
                            </h3>
                        );
                        }}        
                    /> 
                        <img src={y} alt="y" /><span className="yemane"> <span style={{color: "yellow"}}>e</span><span style={{color: "red"}}>m</span><span style={{color: "yellow"}}>a</span><span style={{color: "red"}}>n</span><span style={{color: "yellow"}}>e</span></span> </h2>
                        <small style={{color: "green"}}>&lt;/h2&gt;</small>
                    </div>

                    <div className="intro-wrapper">
                        <div className="nav-wrapper">

                            {/* <!-- Link around dots-wrapper added after tutorial video --> */}
                            <a href="index.html">
                                <div className="dots-wrapper">
                                    <div id="dot-3" className="browser-dot"></div>
                                    <div id="dot-2" className="browser-dot"></div>
                                    <div id="dot-1" className="browser-dot"></div>
                                </div>
                            </a>
                            

                            <ul id="navigation">
                            <li style={{ fontStyle: "bold" }} ><a href="#about">About</a></li>
                            <li style={{ fontStyle: "bold" }} ><a href="#portfolio">Portfolios</a></li>
                                <li style={{ fontStyle: "bold" }} ><a href="#contact">Contact</a></li>

                            </ul>
                        </div>

                        <div className="left-column">
                            <img id="profile_pic" src={yemi}/>
                            <h5 style={{textAlign: "center" }}>Name: Yemane Birhane</h5>
                            <h6 style={{textAlign: "center" }}>Job: Full-Stack Web Developer</h6>
                            <h6 style={{textAlign: "center" }}>DOB: 12-01-1998</h6>
                            <h6 style={{textAlign: "center" }}>Nick_Name: Yemi Bold</h6>
                            <small style={{color: "#fff" }}>Fav Quote: Everybody should Learn to Program a Computer, Because it Teaches you how to Think !</small>
                        </div>

                        <div className="right-column">

                            <div id="preview-shadow">
                                <div id="preview">
                                    <div id="corner-tl" className="corner"></div>
                                    <div id="corner-tr" className="corner"></div>
                                    <small style={{color: "red"}}>&lt;h3&gt;</small> <h3>What I Do</h3><small style={{color: "red"}}>&lt;h3&gt;</small>
                                    <p>I am a Full-Stack Developer so I build websites, mobile apps, desktop apps and solve other Tech Related problems using computer programming.</p>
                                    <div id="corner-br" className="corner"></div>
                                    <div id="corner-bl" className="corner"></div>
                                </div>
                            </div>
                        </div>
                    </div>

                <a name="about"></a>
                    <div className="about-wrapper">
                        <div className="about-me">
                            {/* <h4>ABOUT ME</h4> */}
                            <img src={abt} />
                            <img id="profile-pic" src={yemy} />
                            <p>I design and develop real world projects to solve problems that I imagine  and I try to solve those problems by building tech projects, and build my vission project startups.</p>
                            <p>While I love discussing with others about tech and cs courses, I still take advantage of learning from others and I'm in search of a great team & projects to develop together that makes our world a better place to live.</p>
                            <hr/>
                    </div>
                    <div>
                        <h4>Subscribe to my <a href="https://www.youtube.com/channel/UCxa31O0v4EtW66JeHWAUQkQ"> 
                            <span className="btn btn-outline-danger">YouTube</span> </a> Channel</h4>
                        <img id="social_img" src={ytchannel} /> 
                    </div>
                </div>
            </div>
            </section><br />
            
            <section className="s2"><br />
            <a name="experience"></a>
                <div className="main-container row">
                    <br /><br />
                    <img className="exp" alt="" src={exp} style={{height: "100px"}}/>
                    {/* <h4>EXPERIANCE and SKILLS</h4>                     */}
                     <p><small style={{color: "red"}}>&lt;p&gt;</small>Fullstack Web developer with Great Experience on Django, React, PHP
                        2D game dev with Pygame, and solving problems with Python, C, C++, Java and others. <small style={{color: "red"}}>&lt;/p&gt;</small>
                    <h5>for more info: <a className="btn btn-info button" href = {resume} target = "_blank">View My Resume</a></h5></p>

                    <div className="col-md-6">
                        <div className="social-links">
                            <div className="services">
                            <small style={{color: "red"}}>&lt;h4&gt;</small><h4>Frameworks and Packages</h4> <small style={{color: "red"}}>&lt;/h4&gt;</small>
                            <ul>                                                                   
                                <Progress
                                    status="success"
                                    type="circle"
                                    width={120}
                                    percent={90}
                                /><li>Django</li>
                                <Progress
                                    status="active"
                                    type="circle"
                                    width={80}
                                    percent={80}
                                /><li>Django Rest Framework</li>
                                <Progress
                                    status="active"
                                    type="circle"
                                    width={70}
                                    percent={70}
                                /><li>Tkinter</li>
                                <Progress
                                    status="success"
                                    type="circle"
                                    width={90}
                                    percent={90}
                                /><li>Pygame</li>                                   
                                    <Progress
                                    status="active"
                                    type="circle"
                                    width={85}
                                    percent={85}
                                /><li>React-Js</li>
                                <Progress
                                    status="active"
                                    type="circle"
                                    width={70}
                                    percent={70}
                                /><li>React-Native</li>                                                             
                                </ul>                             
                            </div>                       
                        </div>   
                    </div>

                    <div className="col-md-6"><br /><br />
                        <h4> <small style={{color: "red"}}>&lt;h4&gt;</small>Programming & Markup languages <small style={{color: "red"}}>&lt;h4&gt;</small></h4>
                        <div id="skills">
                            <div className="skill">
                                <span className="name">Python</span>
                                <div className="percent">
                                    <div className="progress" style={{width: '95%'}}></div>
                                </div>
                                <span className="value">95%</span>
                            </div>
                        </div>
                        <div id="skills">
                            <div className="skill exp">
                                <span className="name">Javascript</span>
                                <div className="percent">
                                    <div className="progress" style={{width: '75%'}}></div>
                                </div>
                                <span className="value">75%</span>
                            </div>
                        </div>    
                        <div id="skills">
                            <div className="skill exp1">
                                <span className="name">Java</span>
                                <div className="percent">
                                    <div className="progress" style={{width: '85%'}}></div>
                                </div>
                                <span className="value">85%</span>
                            </div>
                        </div>
                        <div id="skills">
                            <div className="skill exp2">
                                <span className="name">PHP</span>
                                <div className="percent">
                                    <div className="progress" style={{width: '90%'}}></div>
                                </div>
                                <span className="value">90%</span>
                            </div>
                        </div>  
                        <div id="skills">
                            <div className="skill">
                                <span className="name">C</span>
                                <div className="percent">
                                    <div className="progress" style={{width: '95%'}}></div>
                                </div>
                                <span className="value">95%</span>
                            </div>
                        </div>
                        <div id="skills">
                            <div className="skill exp">
                                <span className="name">C++</span>
                                <div className="percent">
                                    <div className="progress" style={{width: '75%'}}></div>
                                </div>
                                <span className="value">75%</span>
                            </div>
                        </div>    
                        <div id="skills">
                            <div className="skill exp1">
                                <span className="name">C#</span>
                                <div className="percent">
                                    <div className="progress" style={{width: '85%'}}></div>
                                </div>
                                <span className="value">85%</span>
                            </div>
                        </div>
                        <div id="skills">
                            <div className="skill exp2">
                                <span className="name">Ruby</span>
                                <div className="percent">
                                    <div className="progress" style={{width: '90%'}}></div>
                                </div>
                                <span className="value">85%</span>
                            </div>
                        </div>                            
                        <div id="skills">
                            <div className="skill exp2">
                                <span className="name">HTML5</span>
                                <div className="percent">
                                    <div className="progress" style={{width: '90%'}}></div>
                                </div>
                                <span className="value">85%</span>
                            </div>
                        </div>
                        <div id="skills">
                            <div className="skill exp1">
                                <span className="name">CSS3</span>
                                <div className="percent">
                                    <div className="progress" style={{width: '85%'}}></div>
                                </div>
                                <span className="value">75%</span>
                            </div>
                        </div> 
                    </div>
                </div>
                <div className="main-container row">
                    <div className="col-md-6">
                       <h4> <small style={{color: "red"}}>&lt;h4&gt;</small>DB and Hosting <small style={{color: "red"}}>&lt;/h4&gt;</small></h4><br/>                      
                        <h5>PostgreSQL</h5>
                            <Progress
                                percent={80}
                                status="error"
                                theme={{
                                    error: {
                                    symbol: '😘',
                                    color: '#fbc630'
                                    }
                                }}
                            />
                            <h5>MySQL</h5>
                            <Progress
                                percent={90}
                                status="error"
                                theme={{
                                    error: {
                                    symbol: '😎',
                                    color: '#20ba34'
                                    }
                                }}
                            />
                            <h5>SQLite3</h5>
                            <Progress
                                percent={90}
                                status="error"
                                theme={{
                                    error: {
                                    symbol: '😜',
                                    color: '#20ba34'
                                    }
                                }}
                            />
                            <h5>Firebase</h5>
                            <Progress
                                percent={80}
                                status="error"
                                theme={{
                                    error: {
                                    symbol: '😃',
                                    color: '#2025ba'
                                    }
                                }}
                            />
                            <h5>Heroku</h5>
                            <Progress
                                percent={75}
                                status="error"
                                theme={{
                                    error: {
                                    symbol: '🤔',
                                    color: '#a620ba'
                                    }
                                }}
                            />                                                                                    
                        <h5>PythonAnyWhere</h5>
                            <Progress
                                percent={75}
                                status="error"
                                theme={{
                                    error: {
                                    symbol: '😘',
                                    color: '#20ba34'
                                    }
                                }}
                            />
                            <h5>InfinityFree</h5>
                            <Progress
                                percent={80}
                                status="error"
                                theme={{
                                    error: {
                                    symbol: '😎',
                                    color: '#fbc630'
                                    }
                                }}
                            />
                        </div>
                        <div className="col-md-6"><br/>
                            <h4> <small style={{color: "red"}}>&lt;h4&gt;</small>Others <small style={{color: "red"}}>&lt;h4&gt;</small></h4><br/>
                            <h5>Bootstrap</h5>

                            <Progress
                                percent={80}
                                status="error"
                                theme={{
                                    error: {
                                    symbol: '😍',
                                    color: '#20ba34'
                                    }
                                }}
                            />  
                            <h5>Material-UI</h5>
                            <Progress
                                percent={70}
                                status="error"
                                theme={{
                                    error: {
                                    symbol: '😎',
                                    color: '#fbc630'
                                    }
                                }}
                            />
                            <h5>Stripe</h5>
                            <Progress
                                percent={60}
                                status="error"
                                theme={{
                                    error: {
                                    symbol: '🤞',
                                    color: '#ba3920'
                                    }
                                }}
                            />                                                                                  
                            <h5>Flutter</h5>
                            <Progress
                                percent={60}
                                status="error"
                                theme={{
                                    error: {
                                    symbol: '😜',
                                    color: '#ba3920'
                                    }
                                }}
                            />                             
                            <h5>Flask</h5>
                            <Progress
                                percent={65}
                                status="error"
                                theme={{
                                    error: {
                                    symbol: '🤔',
                                    color: '#a620ba'
                                    }
                                }}
                            />  
                            <h5>FlexBox</h5>
                            <Progress
                                percent={60}
                                status="error"
                                theme={{
                                    error: {
                                    symbol: '🤷‍♂️',
                                    color: '#ba3920'
                                    }
                                }}
                            />  
                            <h5>Tailwind-CSS</h5>
                            <Progress
                                percent={70}
                                status="error"
                                theme={{
                                    error: {
                                    symbol: '✌',
                                    color: '#fbc630'
                                    }
                                }}
                            />
                    </div>
                </div><br/>
            </section><br/>

            <section className="s1"><a name="portfolio"></a>
                <div className="main-container">
                  <h3 style={{textAlign: "center" }}>
                      <img className="project" src={pro} al="" /></h3>
                    <div className="post-wrapper">
                    
                    <div className="row">
                        <div className="col-md-4">
                            <div className="post">
                                <img className="thumbnail zoom" src={beteseb} alt="Beteseb Demo" />
                                <div className="post-preview">
                                    <h6 className="post-title">Beteseb a chat app</h6>
                                    <p className="post-intro">Beteseb is a chating app that include group and private chating. you don't need to be facebook friends or a follower to chat with your family you just need to add your family to a brand new chat room then boom you can chat with you family. I built this site using reactjs for the frontend, DRF for backend(firebase for demo), and google, and facebook authentication system aswell as new registration system as signin methods</p>
                                    <a style={{float: 'right'}} className="btn btn-success" href="https://beteseb4589.web.app/">View Live Demo</a>
                                </div>
                            </div><br />
                        </div>
                        <div className="col-md-4">
                            <div className="post">
                                <img className="thumbnail zoom" src={addischat} alt="addis_chat" />
                                <div className="post-preview">
                                    <h6 className="post-title">Addis_chat(አዲስ ቻት) a Social Networking site</h6>
                                    <p className="post-intro">I developed this social networking site using reactjs for the frontend, firebase for backend, and google authentication system as signin method</p>
                                    <a style={{float: 'right'}} className="btn btn-success" href="https://addis-chat-70d75.web.app/">View Live Demo</a>
                                </div>
                            </div><br />
                        </div>
                        <div className="col-md-4">
                            <div className="post">
                                <img className="thumbnail zoom" src={addistweet} alt="addistweet" />
                                <div className="post-preview">
                                    <h6 className="post-title">AddisTweet(አዲስ ትዊት) a Social Networking site</h6>
                                    <p className="post-intro">I developed this social networking site using HTML, CSS, JS, FontAwesome for the frontend,  Object-Oriented-PHP for the backend, and and MySQL database</p>
                                    <a style={{float: 'right'}} className="btn btn-success" href="http://addistweet.epizy.com/addischat/">View Live Demo</a>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    <div className="row">
                    <div className="col-md-4">
                            <div className="post">
                                <img className="thumbnail zoom" src={mirchaye} alt="mircaye" />
                                <div className="post-preview">
                                    <h6 className="post-title">Mirchaye(ምርጫዬ) a Dating App</h6>
                                    <p className="post-intro">I developed this Dating and couple matching App using reactjs for Frontend and Django Rest Framework the python web framework for the backend and a simple SQLITE3 database</p>
                                    <a style={{float: 'right'}} className="btn btn-success" href="https://mrchaye-538a3.web.app/">View Live Demo</a>
                                </div>
                            </div><br />
                        </div>

                        <div className="col-md-4">
                            <div className="post">
                                <img className="thumbnail zoom" src={wetok} style={{height: "220px"}} />
                                <div className="post-preview">
                                    <h6 className="post-title">We_Tok a Video Streaming Site</h6>
                                    <p className="post-intro">We_tok is a video sharing site that is built of reactjs and firebase-firestore, material-ui and flex box based on BEM</p>
                                    <a style={{float: 'right'}} className="btn btn-success" href="https://we-tok-48002.web.app/">View Live Demo</a>
                                </div>
                            </div><br />
                        </div>

                        <div className="col-md-4">
                            <div className="post">
                                <img className="thumbnail zoom" src={dec} />
                                <div className="post-preview">
                                    <h6 className="post-title">Online Learning System</h6>
                                    <p className="post-intro">Built with Django and Postgresql, Bootsrap4 and other packages, i developed this Online Learning Managemet System during the COVID19 lockdown cauze education was shut down and i thought it would be great if we learn in home from our college instructors.</p>
                                    <a style={{float: 'right'}} className="btn btn-success" href="http://yemane.pythonanywhere.com/">View Live Demo</a>
                                </div>
                            </div>
                        </div><br />                        
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                                <div className="post">
                                    <img className="thumbnail zoom" src={hms} alt="HMS" />
                                    <div className="post-preview">
                                        <h6 className="post-title">Hospital Management System</h6>
                                        <p className="post-intro">i developed this social networking site using reactjs for the frontend, firebase for backend, and google authentication system as signin method</p>
                                        <a style={{float: 'right'}} className="btn btn-success" href="#">View More</a>
                                    </div>
                                </div><br />
                            </div>

                            <div className="col-md-4">
                                <div className="post">
                                    <img className="thumbnail zoom" src={ecom} />
                                    <div className="post-preview">
                                        <h6 className="post-title">Ecommerce Website</h6>
                                        <p className="post-intro">Bold_Ecommerce built with python-django web framework and postgresql database, Online store with stripe payments intergration and guest user cart</p>
                                        <a style={{float: 'right'}} className="btn btn-success" href="#">View More</a>
                                    </div>
                                </div><br />
                            </div>                        
                    <div className="col-md-4">
                            <div className="post">
                                <img className="thumbnail zoom" src={car} />
                                <div className="post-preview">
                                    <h6 className="post-title">Car Race Game</h6>
                                    <p className="post-intro">a 2D car race game built in Python-Pygame</p>
                                    <a style={{float: 'right'}} className="btn btn-success" href="#">View More</a>
                                </div>
                            </div>
                        </div><br />
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <div className="post">
                                <img className="thumbnail zoom" src={dama} alt="dama" style={{height: "200px"}} />
                                <div className="post-preview">
                                    <h6 className="post-title">Checker/Dama Game</h6>
                                    <p className="post-intro">Yegna Dama built in with python-pygame and minimax algorithm, this Checkers game with single and muliplayer that have an AI for the single player option</p>
                                    <a style={{float: 'right'}} className="btn btn-success" href="#">View More</a>
                                </div>
                            </div>
                        </div><br/>
                        <div className="col-md-4">
                            <div className="post">
                                <img className="thumbnail zoom" src={calc} />
                                <div className="post-preview">
                                    <h6 className="post-title">Scientific Calculator</h6>
                                    <p className="post-intro">a Scientific calculator developed using python-Tkinter package</p>
                                    <a style={{float: 'right'}} className="btn btn-success" href="#">View More</a>
                                </div>
                            </div>
                        </div><br/><br />

                        <div className="col-md-4">
                            <div className="post">
                                <img className="thumbnail zoom" src={car1} />
                                <div className="post-preview">
                                    <h6 className="post-title">Car Race Game</h6>
                                    <p className="post-intro">a 2D car race game built in Python-Pygame</p>
                                    <a style={{float: 'right'}} className="btn btn-success" href="#">View More</a>
                                </div>
                            </div>
                        </div> 
                    </div>                    
                </div>
            </div>    
            </section><br/>
            
            <section className="s1">
                <a name="services"></a>
                {/* <h3 style={{textAlign: "center" }}>Services</h3> */}
                <img className="exp" alt="" src={service} />
                <Services />
            </section> <br />
            <section className="s2"><br /><a name="certificate"></a>
                <div className="main-container">
                    <h3 style={{textAlign: "center" }}>
                        <ReactTypingEffect
                                className="hello"
                                text={["My Certificates"]}
                                eraseDelay="500"
                                typingDelay="1000"
                                cursorRenderer={cursor => <h2>{cursor}</h2>}
                                displayTextRenderer={(text, i) => {
                                return (
                                    <h2>
                                    {text.split('').map((char, i) => {
                                        const key = `${i}`;
                                        return (
                                        <span
                                            key={key}
                                            style={i%2 === 0 ? { color: 'magenta'} : {color: 'yellow'}}
                                        >{char}</span>
                                        );
                                    })}
                                    </h2>
                                );
                                }}        
                            /> 
                    </h3>
                    <Certificates />
                </div><br/>             
            </section><br/> 


            <section className="s3"><a name="contact"></a>
                <div className="main-container">
                    <a href=""></a>
                    <h3 style={{textAlign: "center" }}>
                        <img src={contact} alt="Contact Me"  style={{height: "100px"}} /> </h3>
                    <form id="contact-form">                        
                        <label>Name</label>           
                        <input className="input-field" type="text" value={values.name} onChange={handleInputChange} name="name" placeholder="Your Name" />

                        <label>Subject</label>
                        <input className="input-field" type="text" value={values.subject} onChange={handleInputChange} name="subject" placeholder="eg: web Dev, mobile app, desktop app" />

                        <label>Email</label>
                        <input className="input-field" type="text" value={values.email} onChange={handleInputChange} name="email" placeholder="Your Email Address" />

                        <label>Message</label>
                        <textarea className="input-field" value={values.message} onChange={handleInputChange} name="message" placeholder="Type Your Message Here" ></textarea>

                        <input onClick={handleSubmit} id="submit-btn" type="submit" value="Send" />
                    </form>
                </div>
                <div className="social-links col-md-8">
                    <h4>Contact Me on</h4>
                    <a target="_blank" href="https://www.facebook.com/profile.php?id=100008676510573"><FontAwesomeIcon icon={ faFacebook } style={{ color: "#4267B2" }} /></a>
                    <a target="_blank" href="https://www.instagram.com/yemibold"><FontAwesomeIcon icon={ faInstagram } style={{ color: "#833AB4" }} /></a>
                    <a target="_blank" href="https://www.twitter.com/yemybold"><FontAwesomeIcon icon={ faTwitter } style={{ color: "#1DA1F2" }} /></a>
                    <a target="_blank" href="https://www.youtube.com/channel/UCxa31O0v4EtW66JeHWAUQkQ"><FontAwesomeIcon icon={ faYoutube } style={{ color: "#E62117" }} /></a>
                    <a target="_blank" href="www.linkedin.com/yemanebirhane"><FontAwesomeIcon icon={ faLinkedin } style={{ color: "#OE76A8" }} /></a>
                    <a target="_blank" href="https://www.tiktok.com/@ybg0405?lang=en"><FontAwesomeIcon icon={ faTiktok } style={{ color: "#EE1D52" }} /></a>
                    <a target="_blank" href="https://t.me/yemibold"><FontAwesomeIcon icon={ faTelegram } style={{ color: "#57b7d4" }} /></a>
                </div>    
                                <br />
                        <div id="footer" class="footer footer-expand-md footer-dark bg-dark text-white ">
                            <br />
                            <div class="container">
                            <strong class="container"> &copy; Copyright protected under the MIT licence {(new Date().getFullYear())} | Developed @<a href="https://www.yemitech.com" target="_blank">Yemi-Technologies and Engineering</a> - by <a href="https://yemi-bold.web.app">Yemi-Bold</a> </strong>
                            <a href="#navbar"><FontAwesomeIcon className="totop" icon={faArrowAltCircleUp} style={{ color: "white"}} /></a>
                            </div>
                        </div>

            </section> 
        </div>
    )
}

export default About
